// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"518":"c4fc46c4","527":"5cb31ed1","787":"c4fc46c4"}[chunkId] + ".chunk.css";
};